// Opções fixas de setor usadas nos campos "Setor atual"/"Setor proposto" dos processos de
// Promoção/Enquadramento/Transferência e Desligamento (substituto) — antes eram texto livre.
export const SETOR_OPTIONS = [
    "Logística e Operações",
    "Comercial/Vendas",
    "Recursos Humanos (RH)",
    "Tecnologia da Informação (TI)",
    "Administrativo",
    "Financeiro",
    "Contábil",
    "Compras / Suprimentos",
    "Marketing",
    "Jurídico",
    "Qualidade",
    "Manutenção",
].map(setor => ({ value: setor, label: setor }));
